import Prism from "prismjs";

globalThis.Prism = Prism;
